import {colors} from 'shells/colors/colors';
import {CompanyRegularIcon, PersonCircleRegularIcon, LeadChevronRegularIcon} from 'shells/icon';

import type {EntityTypeFromApi} from '../../../../../ui/core/nutshell-fields/types';

export function getIcon(entityType: EntityTypeFromApi) {
    switch (entityType) {
        case 'Contacts':
            return PersonCircleRegularIcon;
        case 'Leads':
            return LeadChevronRegularIcon;
        case 'Accounts':
            return CompanyRegularIcon;
        default:
            return PersonCircleRegularIcon;
    }
}

export function getIconColor(entityType: EntityTypeFromApi): string {
    switch (entityType) {
        case 'Accounts':
            return colors.company;
        case 'Contacts':
            return colors.person;
        case 'Leads':
            return colors.lead;
        default:
            return colors.person;
    }
}
